import { Link } from 'react-router-dom';
import { Wordmark } from '@/components/Wordmark';
import { useLangHref, useT } from '@/lib/useLang';

export function Footer() {
  const t = useT();
  const withLang = useLangHref();

  return (
    <footer style={{ borderTop: '1px solid var(--nz-border)' }}>
      <div className="nz-footer">
        <Wordmark size="sm" to={withLang('/')} />

        <nav className="nz-footer__nav">
          <Link to={withLang('/white-label')}>{t.whiteLabel.navLabel}</Link>
          <Link to={withLang('/faq')}>FAQ</Link>
          <Link to={withLang('/blog')}>{t.navBlog}</Link>
          <Link to={withLang('/tools')}>{t.navTools}</Link>
          <Link to={withLang('/privacy')}>{t.privacy}</Link>
          <Link to={withLang('/terms')}>{t.terms}</Link>
        </nav>

        <div className="nz-footer__tag">
          <span className="nz-footer__in" aria-hidden="true">
            in
          </span>
          {t.footerTag}
        </div>
      </div>
    </footer>
  );
}
